<template>
  <v-modal id="modalActivityReport">
    <span slot="header"> {{ i18nJS.modal_activity_message }}{{ yesterday }}) </span>
    <form class="form-horizontal">
      <div class="control_group activity_select hide" style="margin-bottom: 5px; display: block">
        <label class="control-label" for="user_ids">{{ i18nJS.user_label }}</label>
        <div class="controls">
          <v-select2
            v-model="params.user_ids"
            :multiple="true"
            :data-ajax--url="searchUserUrl"
            data-minimumInputLength="0"
            data-pageLimit="20"
            id="user_ids"
            class="selectReportActivity"
          >
          </v-select2>
        </div>
      </div>
      <div class="control_group activity_exam_select hide" style="margin-bottom: 5px; display: block">
        <label class="control-label" for="guest_ids">{{ i18nJS.guest_label }}</label>
        <div class="controls">
          <v-select2
            v-model="params.guest_ids"
            :multiple="true"
            :data-ajax--url="searchGuestUrl"
            data-minimumInputLength="0"
            data-pageLimit="20"
            id="guest_ids"
            class="selectReportActivity"
          >
          </v-select2>
        </div>
      </div>
      <div class="control_group activity_select hide" style="margin-bottom: 5px; display: block">
        <label class="control-label" for="activities_config_ids">{{ i18nJS.area }}</label>
        <div class="controls">
          <v-select2
            v-model="params.activities_config_ids"
            :multiple="true"
            :data-ajax--url="searchAreaUrl"
            data-minimumInputLength="0"
            data-pageLimit="20"
            id="activities_config_ids"
            class="selectReportActivity"
          >
          </v-select2>
        </div>
      </div>
      <div class="control_group activity_select hide" style="margin-bottom: 5px; display: block">
        <label class="control-label" for="activity_ids">{{ i18nJS.activity_label }}</label>
        <div class="controls">
          <v-select2
            v-model="params.activity_ids"
            :multiple="true"
            :data-ajax--url="searchActivityUrl"
            data-minimumInputLength="0"
            data-pageLimit="20"
            id="activity_ids"
            class="selectReportActivity"
          >
          </v-select2>
        </div>
      </div>
      <div class="control-group">
        <label class="control-label" for="date_from">{{ i18nJS.from }}</label>
        <div class="controls">
          <datepicker class="input_date obbligatorio" v-model="params.from" required="required" id="date_from" />
        </div>
      </div>
      <div class="control-group">
        <label class="control-label" for="date_to">{{ i18nJS.to }}</label>
        <div class="controls">
          <datepicker class="input_date obbligatorio" v-model="params.to" required="required" id="date_to" />
        </div>
      </div>
    </form>
    <button slot="footer" class="btn btn-success" @click="generateReport" :disabled="invalidForm">
      {{ i18nJS.command.generate }} {{ type }}
    </button>
  </v-modal>
</template>

<script>
import apiConnector from '@/epersonam/apiConnector';
import datepicker from '../datepicker';
import vSelect2 from '../vSelect2';
import vModal from '../vModal';

export default {
  name: 'modalActivityReport',
  props: ['searchUserUrl', 'searchGuestUrl', 'searchAreaUrl', 'searchActivityUrl', 'reportUrl', 'pivotUrl'],
  data() {
    return {
      type: 'pdf',
      params: {
        worker: null,
        user_ids: [],
        guest_ids: [],
        activities_config_ids: [],
        activity_ids: [],
        from: moment().subtract(1, 'days').subtract(1, 'months').format(i18nJS.time.formats.date_only),
        to: moment().subtract(1, 'days').format(i18nJS.time.formats.date_only),
        skip_page_creation: 'false',
        orientation: 'landscape',
      },
    };
  },
  components: {
    vModal,
    vSelect2,
    datepicker,
  },
  computed: {
    invalidForm() {
      return (
        !this.params.from ||
        !this.params.to ||
        !moment(this.params.from, 'DD/MM/YYYY', true).isValid() ||
        !moment(this.params.to, 'DD/MM/YYYY', true).isValid() ||
        moment(this.params.to, 'DD/MM/YYYY', true) < moment(this.params.from, 'DD/MM/YYYY', true)
      );
    },
    iconPrint() {
      switch (this.type) {
        case 'csv':
          return 'file-excel';
        case 'pivot':
          return 'chart-bar';
        default:
          return 'file-pdf';
      }
    },
    i18nJS() {
      return window.i18nJS;
    },
    yesterday() {
      return moment().subtract(1, 'days').format(i18nJS.time.formats.date_only);
    },
    url() {
      if (this.type == 'pivot') {
        return this.pivotUrl;
      } else {
        return this.reportUrl;
      }
    },
    nullActivityIds() {
      return !this.params.activity_ids || this.params.activity_ids.length == 0;
    },
    nullActivitiesConfigIds() {
      return !this.params.activities_config_ids || this.params.activities_config_ids.length == 0;
    },
    nullGuestIds() {
      return !this.params.guest_ids || this.params.guest_ids.length == 0;
    },
    nullUserIds() {
      return !this.params.user_ids || this.params.user_ids.length == 0;
    },
  },
  mounted() {
    eventBus.$on('generateReportGuestActivityMat', (data) => {
      this.type = data.type;
      this.params = {
        worker: data.worker,
        user_ids: [],
        guest_ids: [],
        activities_config_ids: [],
        activity_ids: [],
        from: moment().subtract(1, 'days').subtract(1, 'months').format(this.i18nJS.time.formats.date_only),
        to: moment().subtract(1, 'days').format(this.i18nJS.time.formats.date_only),
        skip_page_creation: 'false',
        orientation: 'landscape',
      };
      $('.selectReportActivity').val([]);
      $('.selectReportActivity').trigger('change');
      $('#modalActivityReport').modal('show');
    });
  },
  methods: {
    generateReport() {
      if (this.nullActivityIds && this.nullActivitiesConfigIds && this.nullGuestIds && this.nullUserIds) {
        return alert(this.i18nJS.alert_message_report_activity);
      }
      let url = this.url;
      Object.keys(this.params).forEach((k) => (url = Utils.addGetParam(url, k, this.params[k])));

      if (this.type == 'pivot') {
        window.open(url);
      } else {
        apiConnector()
          .get(url)
          .then(({ data }) => {
            eventBus.$emit('generateReport', data);
            $('#modalActivityReport').modal('hide');
          });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.obbligatorio {
  border-color: #dd0000;
}
</style>
